// Keeps number runs like 81-00000432 or 2026/10/21 in written order inside Arabic text, app-wide.
const RUN = /\d[\d.:]*(?:[-/][\d.:]*\d)+/g;
const ISO = /[\u2066-\u2069]/g;
const SKIP = new Set(["SCRIPT", "STYLE", "TEXTAREA", "INPUT", "CODE", "PRE", "NOSCRIPT"]);

const fixText = (node) => {
  const v = node.nodeValue;
  if (!v || v.length > 2000 || !/\d[-/]\d|\d[-/][\d.]/.test(v.replace(ISO, ""))) return;
  const p = node.parentElement;
  if (!p || SKIP.has(p.tagName) || p.isContentEditable) return;
  const next = v.replace(ISO, "").replace(RUN, "\u2066$&\u2069");
  if (next !== v) node.nodeValue = next;
};

const walk = (root) => {
  if (root.nodeType === 3) return fixText(root);
  if (root.nodeType !== 1 || SKIP.has(root.tagName)) return;
  const it = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  for (let n = it.nextNode(); n; n = it.nextNode()) fixText(n);
};

export const startBidiFix = () => {
  if (typeof MutationObserver === "undefined" || !document.body) return;
  walk(document.body);
  // Copied text must not carry the invisible isolate marks.
  document.addEventListener("copy", (e) => {
    const sel = String(window.getSelection?.() || "");
    if (!/[\u2066-\u2069]/.test(sel)) return;
    e.clipboardData?.setData("text/plain", sel.replace(ISO, ""));
    e.preventDefault();
  });
  new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === "characterData") fixText(m.target);
      else m.addedNodes.forEach(walk);
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
};
